// Owner Scorecard value formatting. Built on metricValue.js — unknown is "—", never 0.
import { num, toMoney, safePct } from "../metricValue";
import { siteBrandLabel } from "../../../utils/siteBrand";

/** Format a value in a registry unit: count | money | ratio (0..1). */
export const formatUnit = (value, unit) => {
  if (unit === "money") return toMoney(value);
  if (unit === "ratio") return safePct(value);
  const n = num(value);
  return n === null ? "—" : n.toLocaleString();
};

/** The tile's status line: where the number comes from. */
export const sourceBadge = (metric) => {
  if (!metric) return "";
  return metric.connected ? "Live" : metric.source_label;
};

/** "Target 30% or lower" / "No target set" — target is in the metric's unit. */
export const targetLine = (metric) => {
  if (num(metric?.target) === null) return "No target set";
  const t = formatUnit(metric.target, metric.unit);
  if (metric.direction === "down") return `Target ${t} or lower`;
  if (metric.direction === "up") return `Target ${t} or higher`;
  return `Target ${t}`;
};

/** Week-over-week line, or null when either side is unknown. */
export const previousLine = (metric) => {
  const prev = num(metric?.previous);
  if (prev === null) return null;
  return `Prior 7 days: ${formatUnit(prev, metric.unit)}`;
};

/** A site_brand slug gets the label the inbox badge shows; a host brand is already readable. */
export const brandLabel = (row) =>
  row?.kind === "site_brand" ? siteBrandLabel({ site_brand: row.label }) || row.label : row?.label;
